export default __webpack_public_path__ + "static/media/circles-no-2.6ef3237a.ogg";